import React, { createContext, useContext, useEffect, useState } from "react";

const AtuInventoryContext = createContext();

export const AtuInventoryProvider = ({ children }) => {
  const data = "Hii Auth";

  const [atuProductData,setAtuProductData] = useState([])
  const [isValidWithOTP, setIsValidWithOTP] = useState(false);

//   Filter
 const [brandData,setBrandData] = useState([])

  const cacheName = "test-atu-cache";

  const fetchAndCacheData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/atu/get-atu-data`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data from server");
      }

      const data = await response.json();
      const cacheStorage = await caches.open(cacheName);
      await cacheStorage.put(
        `${process.env.REACT_APP_SERVER_URL}/api/atu/get-atu-data`,
        new Response(JSON.stringify(data))
      );
      console.log("ATU Data stored in cache:", data);
      return data;
    } catch (error) {
      console.error("Error fetching and caching data:", error);
      throw error; // Propagate the error further
    }
  };

  const fetchDataFromCache = async () => {
    const cacheStorage = await caches.open(cacheName);
    const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/atu/get-atu-data`;

    try {
      const cachedResponse = await cacheStorage.match(cacheUrl);

      if (cachedResponse) {
        const cachedData = await cachedResponse.json();
        console.log("Data fetched from cache:", cachedData);
        setAtuProductData(cachedData); // Assuming `setProducts` is defined elsewhere
        return cachedData;
      } else {
        return await fetchAndCacheData();
      }
    } catch (error) {
      console.error("Error fetching data from cache:", error);
      throw error; // Propagate the error further
    }
  };


  // useEffect(() => {
  //   fetchDataFromCache();
  // }, []);
  // Function to check the value in localStorage and update the state
  const checkValidWithOTP = () => {
    const storedValue = localStorage.getItem("callApiData");
    setIsValidWithOTP(storedValue === "true");
  };

  // useEffect to check when the component mounts and when localStorage changes
  useEffect(() => {
    // Check on component mount
    checkValidWithOTP();

    // Listen for localStorage changes (useful for multi-tab scenarios)
    const handleStorageChange = () => {
      checkValidWithOTP();
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect to react when validWithOTP changes to true
  useEffect(() => {
    if (isValidWithOTP) {
      // fetchDataFromCache();
    }
  }, [isValidWithOTP]);

//   ATU Brand Filter
const fetchBrandProductData = (atuProductData) => {
    const uniqueBrands = new Set();
  
    const transformedData = atuProductData
      .map((product) => {
        const nyc_brand = product['_nyc_brand_value@OData.Community.Display.V1.FormattedValue'];
        if (!nyc_brand) return null;
        return { label: nyc_brand, value: nyc_brand };
      })
      .filter((item) => item !== null)
      .filter((item) => {
        if (!uniqueBrands.has(item.label)) {
          uniqueBrands.add(item.label);
          return true;
        }
        return false;
      });
  
    return transformedData;
  };
  
  useEffect(() => {
    const fetchBrandData = async (atuProductData) => {
      const brandData = fetchBrandProductData(atuProductData);
      console.log("Transformed ATU BRAND Data:", brandData);
      setBrandData(brandData);
    };
  
    // fetchBrandData(atuProductData);
  }, [atuProductData]);


  // // Algopix Data start
  // const [showPopup, setShowPopup] = useState(false);
  // const handleButtonClick = (upcNumber) => {
  //   setShowPopup(true);
  //   fetchAlgopixData(upcNumber);
  // };
 
  // const handleCloseClick = () => {
  //   setShowPopup(false);
  // };
 
  // const [algopixdata,setAlgoPixdata] = useState(null);
  // const [amazonData, setAmazonData] = useState(null);
  // const [ebayData, setEbayData] = useState(null);
  // const [walmartData, setWalmartData] = useState(null);
 
  // const fetchAlgopixData = async (upcNumber) => {
  //   console.log("inside fetchAlgopixData", upcNumber); 
  //   try {
 
  //     const keywords = "017801147025";
 
  //     const url = `${process.env.REACT_APP_SERVER_URL}/api/atu/get-algopix-data?keywords=${keywords}`;
 
 
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       }
  //     });
 
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch token');
  //     }
     
  //     const data = await response.json();
  //     console.log(data.result);
  //     setAlgoPixdata(data.result);
  //     const amazon = data.result.offers.find(offer => offer.marketBrand === 'AMAZON');
  //     const ebay = data.result.offers.find(offer => offer.marketBrand === 'EBAY');
  //     const walmart = data.result.offers.find(offer => offer.marketBrand === 'WALMART');
 
  //     console.log(amazon);
  //     console.log(ebay);
  //     console.log(walmart);
  //     setAmazonData(amazon);
  //     setEbayData(ebay);
  //     setWalmartData(walmart);
 
  //   } catch (error) {
  //       console.log("Erron", error)
  //   }
  // };
// Algopix Data End's


  return (
    <AtuInventoryContext.Provider value={{ brandData, atuProductData, 
    // handleButtonClick,
    // handleCloseClick,
    // showPopup,
    // algopixdata,
    // amazonData,
    // ebayData,
    // walmartData
     }}>
      {children}
    </AtuInventoryContext.Provider>
  );
};

export const useAtuInventoryContext = () => {
  const context = useContext(AtuInventoryContext);
  if (context === undefined) {
    throw new Error('useAtuInventoryContext must be used within a AtuInventoryProvider');
  }
  return context;
};
